<div class="card">
    <div class="card-body">
        <h4 class="card-title">Interpretaciones</h4>

        <table class="table table-bordered table-hover " >
            <thead>
                <tr>
                    <th >Factor</th>
                    <th >Título</th>
                    <th >Titulo bajo</th>
                    <th >Titulo alto</th>
                    <th >Editar/Borrar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let interpretation of interpretations; index as i">
                    <td >{{interpretation.title}}</td>
                    <td class="footable-visible">{{interpretation.options.low}}</td>
                    <td class="footable-visible">{{interpretation.options.low}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(interpretation)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(interpretation._id)" ><i class="fa fa-eraser" ></i></button>
                    </td>
                </tr>
            </tbody>
     
        </table>
    </div>
</div>
